/** 品牌签名分割线：渐变地平线 + 菱形节点 */
export function renderHorizon(): string {
  return `
    <div class="horizon" role="presentation">
      <span class="node a"></span><span class="node b"></span>
    </div>`;
}
